<script>
export default {
  name: 'LeftPanelLineSection',
  props: {
    lines: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'deleteLine',
    'updateLineName',
    'validateLines',
    'editLine',
  ],
  data () {
    return {
      lineNameData: [],
      disableEdition: false,
    }
  },
  computed: {
    hasLines () {
      return this.lines.length !== 0
    },
  },
  watch: {
    lines: {
      handler() {
        this.lineNameData.length = 0
        this.lineNameData.push(...this.lines.map(line => line.name))
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openDeleteLineDialog (lineIndex) {
      this.$emit('deleteLine', lineIndex)
    },
    editLine (lineIndex) {
      this.disableEdition = true
      this.$emit('editLine', lineIndex)
    },
    onUpdateLineName (index) {
      this.$emit('updateLineName', this.lineNameData[index], index)
    },
    validate () {
      this.disableEdition = false
      this.$emit('validateLines')
    },
  },
}
</script>
<template>
  <section class="left-panel-line-section">
    <v-expansion-panels
      v-if="hasLines"
    >
      <v-expansion-panel
        v-for="(line, lineIndex) in lines"
        :key="lineIndex"
      >
        <v-expansion-panel-title>
          <v-text-field
            v-model="lineNameData[lineIndex]"
            label="Nom de la ligne"
            hide-details
            @click.stop
            @update:model-value="onUpdateLineName(lineIndex)"
          />
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="line-actions-buttons">
            <v-btn
              size="small"
              color="error"
              prepend-icon="fas fa-trash"
              :text="$gettext('Delete line')"
              @click="openDeleteLineDialog(lineIndex)"
            />
            <v-btn
              size="small"
              color="secondary"
              :disabled="disableEdition"
              prepend-icon="fas fa-edit"
              :text="$gettext('Edit line')"
              @click="editLine(lineIndex)"
            />
          </div>
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(segment, segmentIndex) in lines[lineIndex].segments"
              :key="segmentIndex"
              :title="`Segment ${(segmentIndex + 1)}`"
            >
              <v-expansion-panel-text>
                <v-table density="compact">
                  <tbody>
                    <tr>
                      <td class="indicator-label">
                        {{ $gettext('Departure') }}
                      </td>
                      <td>{{ segment.start_address.substr(0, segment.start_address.lastIndexOf(",")) }}</td>
                    </tr>
                    <tr>
                      <td class="indicator-label">
                        {{ $gettext('Arrival') }}
                      </td>
                      <td>{{ segment.end_address.substr(0, segment.end_address.lastIndexOf(",")) }}</td>
                    </tr>
                    <tr>
                      <td class="indicator-label">
                        {{ $gettext('Duration') }}
                      </td>
                      <td>{{ segment.average_duration_text }}</td>
                    </tr>
                    <tr>
                      <td class="indicator-label">
                        {{ $gettext('Distance') }}
                      </td>
                      <td>{{ segment.distance_text }}</td>
                    </tr>
                  </tbody>
                </v-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-btn
        size="small"
        color="secondary"
        prepend-icon="fas fa-circle-check"
        class="validate-btn"
        :text="$gettext('Validate lines')"
        @click="validate"
      />
    </v-expansion-panels>
  </section>
</template>
<style lang="scss" scoped>
.line-actions-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.indicator-label {
  font-weight: 500;
}
.left-panel-line-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.validate-btn {
  margin-top: 10px;
  margin-right: 0;
  margin-left: auto;
}
</style>
